import { Typography, InputLabel, Box } from '@mui/material'
import InputBase from '@mui/material/InputBase'
import { alpha, styled } from '@mui/material/styles'

const BootstrapInput = styled(InputBase)(({ theme, titleName }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 8,
    position: 'relative',
    backgroundColor: theme.palette.mode === 'light' ? '#fcfcfb' : '#2b2b2b',
    border: '1px solid #ced4da',
    fontSize: 16,
    // Conditionally apply width/minWidth if NOT "Event Hashtag"
    ...(titleName !== 'Event Hashtag' && {
      width: 400,
    }),
    minWidth: '193px',
    padding: '8px 10px',
    transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))

const CreateInitiativeInputField = ({
  Id,
  titleName,
  inputProps,
  placeholder,
  defaultValue,
  rows,
  registerFunction,
  onChange,
  onPaste,
  onKeyDown,
  multiline,
}) => {
  return (
    <Box id={Id}>
      <InputLabel shrink htmlFor="bootstrap-input" sx={{ color: '#2e739c' }}>
        <Typography className="headincreateini initiative-titles-st">{titleName}*</Typography>
      </InputLabel>
      {/* Pass titleName to BootstrapInput here */}
      <BootstrapInput
        id="bootstrap-input"
        titleName={titleName}
        placeholder={placeholder}
        inputProps={inputProps}
        defaultValue={defaultValue}
        multiline={multiline}
        rows={rows}
        {...registerFunction()}
        onChange={onChange}
        onPaste={onPaste}
        onKeyDown={onKeyDown}
      />
    </Box>
  )
}

export default CreateInitiativeInputField
